// AXIOS SETUP
import axios from "axios"

axios.defaults.baseURL = 'https://api.supereasy1.com/api/';
axios.defaults.timeout = 60000

axios.interceptors.request.use(function(config) {
	// Do something before request is sent
	config.headers['Content-Type'] = 'text/plain';
	return config;
}, function(error) {
	// Do something with request error
	return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
		let returnable  = response.data
    return returnable
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  });


export {}



// WEBPACK FOOTER //
// ./src/apiConfig.js